import { gateway } from "../../../gateway";
import { ETimePeriods } from "../enums/timesheets.enum";

export const getWorkforceTypeHours = async (period: ETimePeriods) => {
    const response = await gateway.get(`/timesheets/total-hours/roles?period=${period}`);
    return response.data?.data || response.data;
}